export const SET_DATE_REGISTERED = "SET_DATE_REGISTERED";
export const SET_RELATIVE_ENGAGEMENT = "SET_RELATIVE_ENGAGEMENT";
export const SET_TOTAL_TIME_SPENT = "SET_TOTAL_TIME_SPENT";
export const SET_SCHEDULED_VISIT = "SET_SCHEDULED_VISIT";
export const SET_APPLIED = "SET_APPLIED";
export const SET_ACTIVITY_WITH_INSTITUTION = "SET_ACTIVITY_WITH_INSTITUTION";
export const SET_ACTIVITY_WITH_EAB = "SET_ACTIVITY_WITH_MY_INSTITUTION";
export const SET_ENGAGEMENT_STATE = "SET_ENGAGEMENT_STATE";